import { Background, BackgroundColor, backgroundGreyScaleColorsOptions } from "../components/layout"
import { Repeater, types } from "react-bricks/frontend"

import React from "react"

interface FootnotesProps {
    background: { color: BackgroundColor } | BackgroundColor
}

const Footnotes: types.Brick<FootnotesProps> = ({ background }) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <div className="w-full px-6.25 pt-10 pb-16 text-lighter-grey xs:px-10 sm:px-15 sm:py-20 md:px-20 lg:px-[120px] xl:px-36">
                <div className="mx-auto max-w-[1440px]">
                    <Repeater propName="repeater" />
                </div>
            </div>
        </Background>
    )
}

Footnotes.schema = {
    name: "Footnotes",
    label: "Footnotes",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/Footnotes.png`,
    repeaterItems: [
        {
            name: "repeater",
            items: [
                {
                    type: "FootnoteItem",
                    label: "Footnote",
                    min: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: backgroundGreyScaleColorsOptions,
                display: types.OptionsDisplay.Color,
            },
        },
    ],
    getDefaultProps: (): FootnotesProps => ({
        background: { color: BackgroundColor.White },
    }),
}

export default Footnotes
